import { SagasFactory } from '../factories/sagas.factory';
import { TimeframesActions } from './timeframes.actions';
import timeframesActionTypes from './timeframes.actionTypes';
import { TimeframesApi } from './timeframes.api';

const factory = new SagasFactory('timeframes', 'timeframes', TimeframesApi, TimeframesActions, timeframesActionTypes);
export const TimeframesSagas = factory.getSagas();
